import React from "react"
import {
  Tooltip as MuiTooltip,
  TooltipClasses,
  TooltipProps
} from "@mui/material"
import { useStyles } from "./styles"

export type TooltipSize = "sm" | "md" | "lg"
export type TooltipType = "label" | "data"

interface Props extends TooltipProps {
  size?: TooltipSize
  type?: TooltipType
  showTooltip?: boolean
  tooltipClasses?: Partial<TooltipClasses>
}

const Tooltip: React.FC<Props> = ({
  children,
  title,
  size = "sm",
  type = "label",
  showTooltip = true,
  tooltipClasses,
  ...rest
}) => {
  const arrowEnabled = rest.arrow || size !== "sm"
  const { classes, cx } = useStyles({ arrowEnabled })

  if (!title || !showTooltip) return <>{children}</>

  const { tooltip: tooltipClass, ...restTooltipClasses } = tooltipClasses || {}

  return (
    <MuiTooltip
      {...rest}
      title={title}
      classes={{
        tooltip: cx(
          classes.tooltip,
          classes[size],
          classes[type],
          tooltipClass
        ),
        ...restTooltipClasses
      }}
      arrow={arrowEnabled}
      describeChild={rest.describeChild}
    >
      {children}
    </MuiTooltip>
  )
}

export default Tooltip
